import React from "react";
import NavigationDrawer from "../../../components/NavigationDrawer/index";
import Chat from "../../../components/Chat";

function ClientCustomerSupport() {
  return (
    <NavigationDrawer>
      <Chat />
    </NavigationDrawer>
  );
}

export default ClientCustomerSupport;
